import services from '../data/services';
import articles from '../data/articles';

export const SITE_URL = 'https://www.thas-redovisning.se';
export const SITE_NAME = 'THAS Ekonomi och Redovisning';
export const SOCIAL_IMAGE = `${SITE_URL}/social-preview.png`;
export const homepage = {
  path: '/',
  title: 'Redovisningsbyrå i Stockholm | THAS Redovisning',
  description: 'Personlig hjälp med bokföring, löner, deklarationer och bokslut i Stockholm. Fasta bokföringspaket från 499 kr/månad exkl. moms. Kontakta THAS.',
};
export const blogIndex = {
  path: '/blogg',
  title: 'Kunskap om bokföring och företagsekonomi | THAS',
  description: 'Läs THAS guider om bokföring, redovisning och ekonomiska underlag. Praktisk vägledning för dig som driver företag och vill få bättre överblick.',
};
export const indexedPages = [homepage, ...services.map(service => ({ ...service, title: `${service.seoTitle || service.title} | THAS Redovisning`, description: service.seoDescription || service.description, kind: 'service', name: service.title })), blogIndex, ...articles.map(article => ({ ...article, title: `${article.title} | THAS`, kind: 'article', name: article.title }))];

export function pageForPath(pathname) {
  let path = pathname;
  try { path = decodeURIComponent(pathname); } catch { /* Unknown paths remain noindex. */ }
  path = path === '/' ? path : path.replace(/\/+$/, '');
  return indexedPages.find(page => page.path.toLocaleLowerCase('sv') === path.toLocaleLowerCase('sv')) || {
    path, title: 'Sidan hittades inte | THAS Redovisning',
    description: 'Sidan finns inte. Hitta THAS tjänster, bokföringspaket och kontaktuppgifter på startsidan.',
    noindex: true,
  };
}

export function structuredDataFor(page) {
  const canonical = SITE_URL + encodeURI(page.path);
  const organization = {
    '@type': 'Organization', '@id': `${SITE_URL}/#organization`,
    name: SITE_NAME, alternateName: 'THAS Redovisning', url: `${SITE_URL}/`,
    logo: `${SITE_URL}/android-chrome-512x512.png`, email: 'info@thas-redovisning.se', telephone: '+46760211685',
    address: { '@type': 'PostalAddress', addressLocality: 'Stockholm', addressCountry: 'SE' },
    contactPoint: { '@type': 'ContactPoint', telephone: '+46760211685', email: 'info@thas-redovisning.se', contactType: 'customer service', availableLanguage: 'sv' },
  };
  const graph = [organization,
    { '@type': 'WebSite', '@id': `${SITE_URL}/#website`, url: `${SITE_URL}/`, name: SITE_NAME, inLanguage: 'sv-SE', publisher: { '@id': organization['@id'] } },
    { '@type': 'WebPage', '@id': `${canonical}#webpage`, url: canonical, name: page.title, description: page.description, inLanguage: 'sv-SE', isPartOf: { '@id': `${SITE_URL}/#website` }, about: { '@id': organization['@id'] } },
  ];
  if (page.path !== '/') {
    const items = [{ '@type': 'ListItem', position: 1, name: 'Startsida', item: `${SITE_URL}/` }];
    if (page.kind === 'article') items.push({ '@type': 'ListItem', position: 2, name: 'Kunskap', item: `${SITE_URL}/blogg` });
    items.push({ '@type': 'ListItem', position: items.length + 1, name: page.name || 'Kunskap', item: canonical });
    graph.push({ '@type': 'BreadcrumbList', itemListElement: items });
  }
  if (page.kind === 'service') graph.push({ '@type': 'Service', '@id': `${canonical}#service`, name: page.name, description: page.description, url: canonical, provider: { '@id': organization['@id'] }, areaServed: { '@type': 'City', name: 'Stockholm' } });
  if (page.kind === 'article') graph.push({ '@type': 'Article', headline: page.name, description: page.description, mainEntityOfPage: { '@id': `${canonical}#webpage` }, author: { '@id': organization['@id'] }, publisher: { '@id': organization['@id'] }, inLanguage: 'sv-SE' });
  return { '@context': 'https://schema.org', '@graph': graph };
}
